import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { GROUPS_SUB_MENU } from "@constants";
import { TabMenu } from "../../../components";
import BlockedOfficers from "../BlockedOfficers/BlockedOfficers";
import OfficerGroups from "../OfficerGroups/OfficerGroups";

const Groups = props => {
	const { user, router } = props;

	/**
	 * Handles page navigation between the tabs defined in GROUPS_SUB_MENU
	 * @param {Object} obj
	 * @param {Number} tabNumber The number used to identify which tab is being clicked on
	 * @param {String} url The url which will be navigated to
	 */
	const onClickTab = ({ tabNumber, url }) => {
		const thisTab = GROUPS_SUB_MENU.find(tab => tab.type === router.params.viewType);
		if (tabNumber !== thisTab.tabNumber) router.push(url);
	};

	return (
		<Fragment>
			<If condition={user.IsStaffAdmin}>
				<TabMenu
					tabs={GROUPS_SUB_MENU}
					activeTab={
						GROUPS_SUB_MENU.find(tab => tab.type === router.params.viewType).tabNumber
					}
					onClickTab={onClickTab}
					user={user}
				/>
			</If>
			<If condition={router.params.viewType === "officers"}>
				<OfficerGroups user={user} />
			</If>
			<If condition={router.params.viewType === "donothire"}>
				<BlockedOfficers
					user={user}
					router={router}
				/>
			</If>
		</Fragment>
	);
};

Groups.propTypes = {
	router: PropTypes.object.isRequired,
	user: PropTypes.object,
};

Groups.defaultProps = {
	user: {},
};

export default Groups;
